__turbopack_context__.v({
  "footerAnchor": "NbuvWG_footerAnchor",
  "footerListItem": "NbuvWG_footerListItem",
});
